import Toast from "./Toast";

export const downloadFile = ({
    filePath,
    fileName,
    successMessage = "File downloaded successfully",
    onSuccess = null,
    onError = null
}) => {
    try {
        fetch(filePath)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then(blob => {
                // Create a URL for the blob
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;

                // Append to body, click, and cleanup
                document.body.appendChild(link);
                link.click();

                // Cleanup
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

                // Handle success
                if (onSuccess) {
                    onSuccess();
                } else {
                    Toast(successMessage, "success");
                }
            })
            .catch(error => {
                console.error('Download error:', error);
                if (onError) {
                    onError(error);
                } else {
                    Toast("Error downloading sample file", "error");
                }
            });
    } catch (error) {
        console.error('Function error:', error);
        if (onError) {
            onError(error);
        } else {
            Toast("Error downloading sample file", "error");
        }
    }
};